import {
    DashboardOutlined,
    DropboxOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import CustomIcon from '../../components/CustomView/CustomIcon'; 
import invoice_project from '../../../assets/Invoice-wise-projects.png';

export const MenuList = [
    { key: 'dashboard', icon: <DashboardOutlined />, label: 'Dashboard', to: '/dashboard' },

    {
        key: 'workspace_management',
        icon: <CustomIcon image={invoice_project} />,
        label: 'Manage Workspace',
        children: [
            { key: 'enquiry', label: 'Manage Enquiry', to: '/enquiry' },
            { key: 'Quotation', label: 'Manage Quotation', to: '/quotation' },
            // { key: 'Invoice', label: 'Manage Invoice', to: '/invoice' },
            { key: 'manage-vendor', label: 'Manage Vendor', to: '/manage-vendor' },
        ]
    },
    {
        key: 'finance',
        icon: <CustomIcon image={invoice_project} />,
        label: 'Finance',
        children: [
            { key: 'add vendor', label: 'Manage Vendors', to: '/manage-vendor' },
            { key: 'po', label: 'Purchase Order', to: '/purchase-order' },
            // {
            //     key: 'reprots', label: 'Reports', to: '/finance/reports',
            //     children: [
            //         { key: 'P & L Report', label: 'P & L Report', to: '/finance/reports/p-l' },
            //         { key: 'Pay Mode Vise Reprt', label: 'Pay Mode Vise Reprt', to: '/finance/reports/pay-mode-vise' },
            //     ]
            // },
        ]
    },


    {
        key: 'compy_assets',
        icon: <DropboxOutlined />,
        label: 'Assets',
        children: [
            { key: 'Bank details', label: 'Manage Bank Details', to: '/manage-bank-data' },
            { key: 'Letter_Formats', label: 'Letter Formats', to: '/manage-letter-formats' },
        ]
    },
   { key: 'manage_services', icon: <SettingOutlined />, label: 'Service Configuration', to: '/manage-services' },

];

